import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import specializedImg from "../../../../assets/imgs/services/international/specialized.jpg";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

function Specialized() {
  const [tSpecialized] = useTranslation("specializedPage");
  const [tSMetaData] = useTranslation("metaData");
  const idSpecialized = "fa1b236b-b81e-47b0-87e8-960dde11a627";
  const [textDescription, setTextDescription] = useState("");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[1]
    }/${Object.keys(navBarEs["products-internacional-submenu"])[2]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[1]
    }/${Object.keys(navBarEn["products-international-submenu"])[2]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idSpecialized}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      )
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("specialized.title")}</title>
        <meta
          name="description"
          content={tSMetaData("specialized.description")}
        />
      </Helmet>
      <ImageHeader
        section={tSpecialized("header.section")}
        title={tSpecialized("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tSpecialized("description.content"))
        }
        contactSales={tSpecialized("header.contact-sales")}
        contactProductID="btnContactSpecialized"
        imgBackground={specializedImg}
      />
    </>
  );
}

export default Specialized;
